import type { State } from 'app/common/ui-components/filter'

import { flags as group } from './group'
import { flags as groupComplexesSpecial } from './groupComplexesSpecial'

const activity = (state: State) => {
  if (group.byProductTypeSelected(state) || groupComplexesSpecial.byPaymentMethodSelected(state)) {
    return false
  }
  return (
    group.byAnyComplexesNotSelected(state) && groupComplexesSpecial.byAnyComplexesNotSelected(state)
  )
}

export default activity
